import React from 'react';
import { useSelector } from 'react-redux';
import config from 'react-global-configuration';
import { CoreLink } from '..';

import { DEFAULT_LANGUAGE, NLDOET_DOMAIN } from '../../config/constants';

import './style.scss';

const Breadcrumbs = ({ includeCurrent, hideHome, customCrumbs = null }) => {
  const domain = config.get('CURRENT_DOMAIN');
  const defaultBreadcrumbs = useSelector((state) => state.getIn(['entity', 'breadcrumbs']));
  const breadcrumbs = customCrumbs ?? defaultBreadcrumbs;
  const parentIsHome = breadcrumbs.size === 1 && breadcrumbs.get(0).get('url') === '/';

  const { currentTitle, currentUrl, fullTitle } = useSelector((state) => {
    const entityId = state.getIn(['entity', 'entityId']);
    const entityType = state.getIn(['entity', 'entityType']);
    const entity = state.getIn([entityType, entityId]);
    if (!entity) {
      return { currentTitle: null, currentUrl: null };
    }
    const title = entity.getIn(['title', 0, 'value']);
    const url = entity.getIn(['paths', DEFAULT_LANGUAGE]);
    const truncatedTitle = title.length > 20 ? `${title.substring(0, 20)}...` : title;

    return { currentTitle: truncatedTitle, currentUrl: url, fullTitle: title };
  });

  // Render the desktop breadcrumbs
  let breadcrumbItems = breadcrumbs.map((item, index) => {
    const url = item.get('url');
    let title = item.get('title');

    if (domain === NLDOET_DOMAIN && (hideHome && index === 0 || parentIsHome)) {
      return;
    }

    if (hideHome && index === 1) {
      title = 'Home';
    }

    title = title.length > 20 ? `${title.substring(0, 20)}...` : title;
    return (
      <li key={url} className="Breadcrumbs__wrapper__item" property="itemListElement" typeof="ListItem">
        <CoreLink
          property="item"
          typeof="WebPage"
          to={url}
        >
          {title}
          {title.length > 20 && (
            <div className="tooltip">
              {item.get('title')}
            </div>
          )}
        </CoreLink>
        <meta property="position" content={index} />
      </li>
    );
  }).filter(Boolean);
  // Returning early when nothing to add results in an undefined, this filter removes those values

  // Render our mobile breadcrumb
  const mobileBreadcrumb = () => {
    const secondToLastBreadcrumb = breadcrumbs.get(breadcrumbs.size - 1, null);

    if (secondToLastBreadcrumb) {
      let title = secondToLastBreadcrumb ? secondToLastBreadcrumb.get('title') : null;
      title = title.length > 20 ? `${title.substring(0, 20)}...` : title;

      return (
        <div className="Breadcrumbs__mobile_box">
          <div className="Breadcrumbs__mobile_box__left">
            <i className="icon icon-arrow-left" />
          </div>
          <div className="Breadcrumbs__mobile_box__right">
            <div>
              <CoreLink property="item" typeof="WebPage" to={secondToLastBreadcrumb.get('url')}>
                Naar {title}
              </CoreLink>
            </div>
          </div>
        </div>
      );
    }
  };

  // Check if we need to include the current page in the breadcrumbs
  if (includeCurrent && !parentIsHome && currentTitle && currentUrl) {
    const index = breadcrumbItems.size + 1;
    breadcrumbItems = breadcrumbItems.push(
      <li key={currentUrl} className="Breadcrumbs__wrapper__item" property="itemListElement" typeof="ListItem">
        <CoreLink
          property="item"
          typeof="WebPage"
          to={currentUrl}
        >
          {currentTitle}
          {fullTitle.length > 20 && (
            <div className="tooltip">
              {fullTitle}
            </div>
          )}
        </CoreLink>
        <meta property="position" content={index} />
      </li>,
    );
  }

  const shouldRender = breadcrumbItems.length > 0 || (includeCurrent && !parentIsHome && currentTitle && currentUrl);

  if (!shouldRender) return;

  return (
    <div className="Breadcrumbs">
      {/* Mobile breadcrumb */}
      {mobileBreadcrumb()}

      {/* Desktop breadcrumbs */}
      <ol className="Breadcrumbs__wrapper" vocab="https://schema.org/" typeof="BreadcrumbList">
        {breadcrumbItems}
      </ol>
    </div>
  );
};

export default Breadcrumbs;
